export default function min(a: number, b: number /*can be NaN*/) {
    return isNaN(b) ? a : Math.min(a, b);
}
